import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/Login';
import Register from './pages/Register';
import CustomerDashboard from './pages/CustomerDashboard';
import StaffDashboard from './pages/StaffDashboard';
import ComplaintDetail from './pages/ComplaintDetail';
import AdminDepartments from './pages/AdminDepartments';
import AdminAreas from './pages/AdminAreas';
import AdminUsers from './pages/AdminUsers';
import PublicComplaint from './pages/PublicComplaint';
import TrackComplaint from './pages/TrackComplaint';

const HomeRedirect = () => {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/public-complaint" replace />;
  if (user.role === 'customer') return <Navigate to="/dashboard" replace />;
  return <Navigate to="/staff-dashboard" replace />;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <div className="d-flex flex-column min-vh-100">
          <Navbar />
          <main className="flex-grow-1">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomeRedirect />} />
              <Route path="/public-complaint" element={<PublicComplaint />} />
              <Route path="/track-complaint" element={<TrackComplaint />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Customer Protected Routes */}
              <Route element={<ProtectedRoute allowedRoles={['customer']} />}>
                <Route path="/dashboard" element={<CustomerDashboard />} />
              </Route>

              {/* Staff / Dept Head / Employee / Agent / Manager / Admin / Representative Protected Routes */}
              <Route element={<ProtectedRoute allowedRoles={['dept_head', 'employee', 'agent', 'manager', 'admin', 'representative']} />}>
                <Route path="/staff-dashboard" element={<StaffDashboard />} />
              </Route>

              {/* Shared Complaint Details View */}
              <Route element={<ProtectedRoute allowedRoles={['customer', 'dept_head', 'employee', 'agent', 'manager', 'admin', 'representative']} />}>
                <Route path="/complaints/:id" element={<ComplaintDetail />} />
              </Route>

              {/* Admin Only Routes */}
              <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/departments" element={<AdminDepartments />} />
                <Route path="/admin/areas" element={<AdminAreas />} />
              </Route>

              {/* Fallback Catch-all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  </LanguageProvider>
  );
}

export default App;
